import { render, staticRenderFns } from "./ChongRecord.vue?vue&type=template&id=7091c306&scoped=true"
import script from "./ChongRecord.vue?vue&type=script&lang=js"
export * from "./ChongRecord.vue?vue&type=script&lang=js"
import style0 from "./ChongRecord.vue?vue&type=style&index=0&id=7091c306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091c306",
  null
  
)

export default component.exports